// relational_load strategy (parquet_processed → postgres): upserts the
// processed parquet into the relational target via element→table/column
// bindings. Read-only info panel; bindings are edited in the dictionary.
import { Link } from "react-router-dom";
import { createPageUrl } from "@/utils";
import { registerStrategyKind } from "../registry";

function RelationalLoadPanel() {
  return (
    <div className="p-6">
      <h2 className="text-lg font-semibold mb-1">Relational Load transformation</h2>
      <p className="text-sm text-gray-500 max-w-2xl mb-4">
        parquet_processed → postgres. Reads the processed parquet
        (validDataElements) and upserts rows into the relational target using
        each element's target_table / target_column binding. Implemented by
        <code className="mx-1">cortex.strategy.relational_load.apply</code>.
      </p>
      <Link to={createPageUrl("data-elements")}
        className="inline-block rounded-lg border border-gray-200 px-4 py-2 hover:border-blue-400 hover:bg-blue-50 no-underline text-gray-800">
        Edit target bindings (Elements)
      </Link>
    </div>
  );
}

registerStrategyKind("relational_load", { label: "Relational Load", Panel: RelationalLoadPanel });
